import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import axios from 'axios'
import VueAxios from 'vue-axios'
import './registerServiceWorker'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 引入api目录下的index.js
import api from './api/'
Vue.use(ElementUI,VueAxios, axios);

Vue.prototype.$axios = axios
Vue.prototype.$store = store
Vue.config.productionTip = false

// axios.defaults.headers.common['x-manager-token'] = store.state.token;

let getTime = Number(localStorage.getItem('getTime'))
let hours = 8*60*60*1000
if(+new Date() - getTime > hours){
  store.commit('deleInfo')
  store.commit('deleteConfig')
  store.commit('deleteProvince') 
}

import  './assets/scss/reset.scss'
import  './assets/scss/style.scss'
 
//再将api挂载到vue的原型上就可以使用了
Vue.prototype.$api = api

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
